import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'lib-bo-auth-feature-item',
  standalone: true,
  templateUrl: './bo-auth-feature-item.component.html',
  styleUrls: ['./bo-auth-feature-item.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoAuthFeatureItemComponent {
  readonly title = input.required<string>();
  readonly description = input.required<string>();
  readonly iconColor = input('#1f9f56');
}
